import api from "../axios/inventory";

const getTenant = () => {
  return sessionStorage.getItem("acc_id");
};
export async function getAllInternalOrderedDevices() {
  const tenantId = getTenant();
  const response = await api.get(`/inventory/${tenantId}/bulk-orders/`);
  return response.data;
}
const getLocationId = () => {
  return JSON.parse(sessionStorage.getItem("current_loc"))?.id;
};

export async function createBulkOrder(data) {
  const tenantId = getTenant();
  const response = await api.post(
    `/inventory/${tenantId}/1/bulk-orders/create/`,
    data
  );
  return response.data;
}

export async function getDeviceTypes() {
  const tenantId = getTenant();
  const response = await api.get(`/inventory/${tenantId}/device-types/`);
  return response.data;
}
export async function getAvailableDevices() {
  const tenantId = getTenant();
  const locationId =getLocationId();

  const response = await api.get(`/devices/${tenantId}/${locationId}/devices/search/`);
  return response.data;
}

export async function searchDevices(query) {
  const tenantId = getTenant();
  const response = await api.get(
    `/devices/${tenantId}/1/devices/search/?q=${encodeURIComponent(query)}`
  );
  return response.data;
}